"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
var environment_1 = require("../utils/environment");
var variables_1 = require("./variables");
var cache_1 = require("../utils/cache");
function normalizeBaseUrl(region, baseUrl) {
    if (baseUrl) {
        return baseUrl;
    }
    if ((environment_1.IS_CI || environment_1.IS_LOCAL || environment_1.IS_QA) && region === 'cn') {
        return variables_1.ServerUrls['cn-qa'];
    }
    if (environment_1.IS_RELEASE && region === 'cn') {
        return variables_1.ServerUrls['cn-release'];
    }
    if (environment_1.IS_PROD && region === 'cn') {
        return variables_1.ServerUrls['cn-prod'];
    }
    if (environment_1.IS_PROD && region === 'us') {
        return variables_1.ServerUrls['us-prod'];
    }
    if (environment_1.IS_PROD && region === 'eu') {
        return variables_1.ServerUrls['eu-prod'];
    }
}
var Config = /** @class */ (function () {
    function Config(gConfig, config) {
        this.gConfig = gConfig;
        this.config = config;
        var baseAccountUrl = config.baseAccountUrl, cacheTTL = config.cacheTTL, disableCache = config.disableCache;
        this._baseUrl = normalizeBaseUrl(this.gConfig.Region, baseAccountUrl);
        this._cahceTTL = cacheTTL || 60 * 1000;
        this._enableCache = !disableCache;
    }
    Object.defineProperty(Config.prototype, "BaseUrl", {
        get: function () {
            return this._baseUrl;
        },
        enumerable: false,
        configurable: true
    });
    Config.prototype.makeCache = function () {
        return new cache_1.CacheData(this._enableCache, this._cahceTTL);
    };
    return Config;
}());
exports.Config = Config;
//# sourceMappingURL=config.js.map